module.exports = __webpack_public_path__ + "static/media/HeroImage.99047a9f.png";